export const DAY_OF_WEEK_TAB_X_PADDING_PX = 10;
export const DAY_OF_WEEK_TAB_ITEMS_MAX_GAP_PX = 33;
export const DAY_OF_WEEK_TAB_HEIGHT_PX = 50;
